<div class="also-included-container">

  <div class="title">{{getString('alsoIncludedIn')}}</div>

  <div>
    <app-grid-item class="bundle-image" [item]="bundle" [small]="true" (onItemClicked)="bundleClick()"
    [priceHint]="'offerslist'" [showQuality]="false" [isCarouselItem]="true"></app-grid-item>

    <div class="bundle-infos">
      <div class="bundle-title" (click)="bundleClick()">{{bundle.title}}</div>
      <img alt="" *ngIf="showHdQualityLogo()" class="quality-logo" src="./assets/images/hd-icon.png">
      <img alt="" *ngIf="bundle.has4K == 1" class="quality-logo" src="./assets/images/4k-icon.png">
      <img alt="" *ngIf="bundle.hdrFormat == 1" class="quality-logo" src="./assets/images/dolby_vision.png">
      <img alt="" *ngIf="bundle.hdrFormat == 2" class="quality-logo" src="./assets/images/hdr.png">
      <img alt="" *ngIf="bundle.hasAtmos == 1" class="quality-logo" src="./assets/images/dolby_atmos.png">
      <p>{{getString('moviesInBundle')}}: {{bundle.itemCount}} {{getString('movies')}}</p>
      <div *ngIf="bundle.saveOpportunity" class="save-text">
        {{getString('saveText1')}} <span class="save-price">{{saveOpportunity}}</span> {{getString('saveText2')}}
      </div>

    </div>

  </div>

</div>
